export default "__VITE_ASSET__CMx1_LzJ__"